import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

// T-042.img: only the reliably-working flow modes are offered. The "behind /
// overlay / front" layering modes were removed — an inline image atom cannot be
// layered behind page text without a full floating-layer feature, and the hack
// made images disappear behind the sheet. Legacy values degrade to inline.
const WrapSection = ({ wrap, onWrapChange }) => (
  <div className="space-y-3">
    <h3 className="font-semibold text-sm">Ajuste de Texto</h3>
    <Select value={wrap} onValueChange={onWrapChange}>
      <SelectTrigger>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="inline">En línea con el texto</SelectItem>
        <SelectItem value="float-left">Flotar a la izquierda</SelectItem>
        <SelectItem value="float-right">Flotar a la derecha</SelectItem>
      </SelectContent>
    </Select>
    <p className="text-xs text-slate-500 dark:text-slate-400">
      {wrap === 'inline' && 'La imagen se muestra en línea con el texto'}
      {wrap === 'float-left' && 'El texto fluye alrededor por la derecha'}
      {wrap === 'float-right' && 'El texto fluye alrededor por la izquierda'}
    </p>
  </div>
);

export default WrapSection;
